import React from 'react'
import PropTypes from 'prop-types'

import { BarChart, DashboardChartPaper } from 'components'

import { routes } from 'Routes'

const RiskByDepartment = ({ processStats, ...rest }) => {
  const totalRisks = (dept) =>
    Object.values(dept.risks || {}).reduce((sum, v) => sum + v, 0)

  const departments = processStats?.departments
    ?.sort((a, b) => totalRisks(b) - totalRisks(a))
    .slice(0, 4)

  const riskNames = [
    ...new Set(
      (departments || []).flatMap((dept) => Object.keys(dept.risks || {})),
    ),
  ]

  const names = (departments || []).map((dept) => dept.name)

  const series = riskNames.map((riskName) => ({
    name: riskName,
    data: (departments || []).map((dept) => dept.risks?.[riskName] || 0),
  }))

  return (
    <DashboardChartPaper
      title="Risco por Departamento"
      subtitle="Distribuição de riscos por departamento"
      redirect={routes.dataProcess.all}
      {...rest}
    >
      <BarChart
        names={names}
        series={series}
        heightValue={250}
        id="contribute-by-risk-chart"
        showLabels
      />
    </DashboardChartPaper>
  )
}

RiskByDepartment.propTypes = {
  processStats: PropTypes.object.isRequired,
}

export default RiskByDepartment
